import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';

import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding, HostListener, ElementRef } from '@angular/core';

import { SnTip } from '@lib/api/entities';
import { ALERT_NOTIFICATION_VERSION } from '@lib/axon/services/alerts.constants';
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[fs-tip-toast]',
  templateUrl: './tip-toast.component.html',
  styleUrls: ['./tip-toast.component.scss'],
  preserveWhitespaces: false,
  animations: [
    trigger('flyInOut', [
      state(
        'inactive',
        style({
          opacity: 0,
        }),
      ),
      transition(
        'inactive => active',
        animate(
          '400ms ease-out',
          keyframes([
            style({
              transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
              opacity: 0,
            }),
            style({
              transform: 'skewX(20deg)',
              opacity: 1,
            }),
            style({
              transform: 'skewX(-5deg)',
              opacity: 1,
            }),
            style({
              transform: 'none',
              opacity: 1,
            }),
          ]),
        ),
      ),
      transition(
        'active => removed',
        animate(
          '400ms ease-out',
          keyframes([
            style({
              opacity: 1,
            }),
            style({
              transform: 'translate3d(100%, 0, 0) skewX(30deg)',
              opacity: 0,
            }),
          ]),
        ),
      ),
    ]),
  ],
})
export class TipToastComponent extends Toast {
  @HostBinding('style.border')
  public border = 'none';

  @HostBinding('style.box-shadow')
  public boxShadow = '0 0 12px #999999;';

  public tip: SnTip;

  private wasInside = false;
  cxVersion?: string;

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
    public element: ElementRef,
  ) {
    super(toastrService, toastPackage);
    this.cxVersion = ALERT_NOTIFICATION_VERSION.LEGACY_CX;
  }

  @HostListener('click', ['$event'])
  public onClick(event: Event): void {
    if (this.element.nativeElement.contains(event.target)) {
      this.border = '3px solid rgba(81, 203, 238, 1)';
      this.boxShadow = '0 0 5px rgba(81, 203, 238, 1)';
      this.wasInside = true;
    }
  }

  @HostListener('document:click')
  public clickout(): void {
    if (!this.wasInside) {
      this.border = 'none';
      this.boxShadow = '0 0 12px #999999;';
    }
    this.wasInside = false;
  }
}
